export const TOGGLE_SH_IMPORT = 'TOGGLE_SH_IMPORT';
export const SENT_DATA = 'SENT_DATA';
export const DATA_VALIDATIONS = 'DATA_VALIDATIONS';
export const TOGGLE_VALIDATION_MODAL = 'TOGGLE_VALIDATION_MODAL';
export const SET_EXTERNAL_DATA = 'SET_EXTERNAL_DATA';
export const SET_OPTIMA_TRIPS = 'SET_OPTIMA_TRIPS';
export const TOGGLE_ADD_PRODUCT = 'TOGGLE_ADD_PRODUCT';
